import { withInstall } from '../../../utils/with-install'
import CircleMarker from './CircleMarker.vue'

export const ElAmapCircleMarker = withInstall(CircleMarker)
export default ElAmapCircleMarker
